<template>
  <footer-item :clickHandler="goToContact" :text="contactLabel"></footer-item>
</template>

<script>

import FooterItem from './FooterItem';

export default {
  computed: {
    contactLabel() {
      return this.$gettext('Contact');
    }
  },
  methods: {
    goToContact() {
      const prefix = this.$language.isEnglish() ? 'en/': '';
      window.open(`https://www.cgpgroup.com/${prefix}site/contact`, '_blank');
    }
  },
  components: {FooterItem}
};
</script>
